import { UrlApi } from "../../../../../services/apirest";

export const getCuentaCorrienteSoloPendientes = async (cliente) => {
  console.log("Props del cliente: ", cliente);
  const response = await fetch(
    `${UrlApi}/comprobantes/ledger/soloPendientes/${cliente.id}/${cliente.id_negocio_cliente}`,
  );

  if (!response.ok)
    throw new Error(
      "Ocurrio un obtener los movimientos pendientes de la cuenta corriente ",
    );

  return await response.json();
};
